import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useParams } from 'react-router-dom';
import { database } from '../../Firebase';
import { ref, onValue } from 'firebase/database';

const Namuna12Receipt = ({ transaction: propTransaction, onPrintComplete }) => {
  const { id } = useParams();
  const [transaction, setTransaction] = useState(propTransaction || null);
  const [loading, setLoading] = useState(!propTransaction);

  useEffect(() => {
    if (propTransaction) {
        setTransaction(propTransaction);
        setLoading(false);
        return;
    }
    if (!id) return;
    const txRef = ref(database, `Grampanchayat/Panipuravtha/Transactions/RokhNave/${id}`);
    onValue(txRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        setTransaction(data);
      }
      setLoading(false);
    });
  }, [id, propTransaction]);

  useEffect(() => {
    if (!loading && transaction) {
      setTimeout(() => window.print(), 500); 
    }
  }, [loading, transaction]);

  if (loading) return <div>Loading...</div>;
  if (!transaction) return <div>Transaction not found</div>;

  const amountInWords = '_________________________';

  const ReceiptCopy = () => (
    <div className="border-2 border-black rounded-3xl p-6 w-[48%] h-full flex flex-col justify-between text-base font-medium relative">
      <div className="text-center font-bold mb-4">
        <h1 className="text-xl">ग्रामपंचायत इनाम धामणी</h1>
        <h2 className="text-2xl mt-2">नमुना १२</h2>
      </div>

      <div className="mb-4 text-sm font-bold">
        <span>तारीख : {transaction.date ? new Date(transaction.date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }).replace(/ /g, '/') : ''}</span>
      </div>

      <div className="border-t-2 border-black mb-4"></div>

      <div className="mb-4">
        <span>प्रमाणक (व्हाऊचर) क्रमांक :- {transaction.voucherNo || ''}</span>
      </div>

      <div className="flex justify-between mb-4">
        <span>ठराव क्रमांक : &nbsp;&nbsp; {transaction.resolutionNo || ''}</span>
        <span>तारीख : {transaction.resolutionDate ? new Date(transaction.resolutionDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }).replace(/ /g, '/') : ''}</span>
      </div>

      <div className="mb-4">
        <span>व्यक्तीचे नाव : &nbsp;&nbsp; {transaction.personName}</span>
      </div>

      <div className="mb-6 text-justify leading-relaxed">
        <p>
          बिलात दर्शविलेली रुपये <span className="font-bold">{parseFloat(transaction.totalAmount || 0).toFixed(2)}</span> ची रक्कम मंजूर करण्यात येत आहे.
        </p>
        <p className="mt-2">
          दाव्याच्या पूर्ण फेडीबद्दल रु. <span className="font-bold">{parseFloat(transaction.totalAmount || 0).toFixed(2)}</span> (अक्षरी) <span className="font-bold">{amountInWords}</span> ची रक्कम मिळाली.
        </p>
      </div>

      <div className="mb-10">
        <p>माझ्यासमोर रक्कम दिली <span className="font-bold">{parseFloat(transaction.totalAmount || 0).toFixed(2)}</span></p>
      </div>

      <div className="mb-16">
        <p className="font-bold">सरपंच :</p>
      </div>

      <div className="flex justify-between items-end mt-auto px-4">
        <div className="flex flex-col items-center w-40">
           <div className="border-t border-black w-full mb-1"></div>
           <span className="text-sm">पैसे घेणाराची सही</span>
        </div>
        <div className="border border-black w-24 h-20 flex items-center justify-center text-lg font-bold">
            मुद्रांक
        </div>
      </div>
    </div>
  );



  // ... (previous logic remains same)

  return ReactDOM.createPortal(
    <div className="bg-white min-h-screen font-poppins text-black fixed inset-0 z-[9999] overflow-auto flex items-center justify-center left-0 top-0 w-full h-full">
      <style>{`
        @media print {
            @page {
                size: landscape;
                margin: 0.5cm;
            }
          body * {
            visibility: hidden;
          }
          #namuna12-receipt, #namuna12-receipt * {
            visibility: visible;
          }
          #namuna12-receipt {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: space-between;
            padding: 20px;
            gap: 40px;
          }
          .no-print {
            display: none !important;
          }
        }
      `}</style>
       
       {onPrintComplete && (
            <button 
                onClick={onPrintComplete} 
                className="fixed top-4 right-4 bg-red-600 text-white px-4 py-2 rounded shadow no-print z-[10000] hover:bg-red-700 font-bold"
            >
                Close
            </button>
       )}
      
      <div id="namuna12-receipt" className="flex justify-between w-full max-w-[1100px] mx-auto gap-10 p-4 bg-white shadow-lg print:shadow-none">
          <ReceiptCopy />
          <ReceiptCopy />
      </div>
    </div>,
    document.body
  );
};

export default Namuna12Receipt;
